import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {PreviewType} from '@presentation/pages/textile-data/creel/add/preview-type';
import {OverviewListCreel} from '@presentation/pages/textile-data/creel/overview/overview-list-creel';

@Component({
  selector: 'app-creel-mapping-edit',
  templateUrl: './creel-mapping-edit.component.html',
  styleUrls: ['./creel-mapping-edit.component.scss']
})
export class CreelMappingEditComponent {
  @Input() public creelForm: FormControl<OverviewListCreel>;

  public get creel(): OverviewListCreel {
    return this.creelForm.value;
  }

  private _previewTypes: {[index: number]: PreviewType} = {};

  public getPreviewType(index: number): PreviewType {
    return this._previewTypes[index] ?? PreviewType.COLOR;
  }

  public togglePreviewType(event: MatSlideToggleChange, index: number): void {
    this._previewTypes[index] = event.checked ? PreviewType.YARN_TYPE : PreviewType.COLOR;
  }
}
